






import Vue from "vue";
export default Vue.extend({
    name: "ToolbarMenuButton",
    props: {
        mobile: { type: Boolean, required: true },
        action: { type: Function, required: true }
    }
});
